import React from 'react';
import { Helmet } from "react-helmet";

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Tulvod - Ihr Experte fuer urbane Mobilitaet</title>
        <meta name="description" content="Tulvod - Entdecken Sie die besten Tipps, Routen und Informationen rund um Fahrradverleih und urbane Mobilitaet in Deutschland. Ihr Experte fuer Fahrradtouren und nachhaltige Fortbewegung." />
      </Helmet>

      <div className="policy-container">
      <h1>Datenschutzerklärung</h1>
      <p><strong>Letzte Aktualisierung:</strong> {new Date().toLocaleDateString('de-DE')}</p>

      <section>
        <h2>1. Einleitung</h2>
        <p>
          Willkommen bei Tulvod ("wir", "uns", "unser"). Wir respektieren Ihre Privatsphäre 
          und verpflichten uns, Ihre personenbezogenen Daten zu schützen. Diese Datenschutzerklärung 
          informiert Sie darüber, wie wir mit Ihren personenbezogenen Daten umgehen, wenn Sie unsere 
          Website tulvod-de.com besuchen.
        </p>
      </section>

      <section>
        <h2>2. Verantwortlicher</h2>
        <p>
          Verantwortlich für die Datenverarbeitung auf dieser Website ist:
        </p>
        <p>
          Fahrradverleih Service<br />
          Ederring 7<br />
          01775 Starnberg<br />
          Deutschland<br />
          Telefon: +4990874455288<br />
          E-Mail: tulvod@hotmail.com
        </p>
      </section>

      <section>
        <h2>3. Erhebung und Speicherung personenbezogener Daten</h2>
        <h3>3.1 Beim Besuch der Website</h3>
        <p>
          Beim Aufrufen unserer Website werden durch den auf Ihrem Endgerät zum Einsatz kommenden 
          Browser automatisch Informationen an den Server unserer Website gesendet. Diese Informationen 
          werden temporär in einem sogenannten Logfile gespeichert. Folgende Informationen werden dabei 
          erfasst:
        </p>
        <ul>
          <li>IP-Adresse des anfragenden Rechners</li>
          <li>Datum und Uhrzeit des Zugriffs</li>
          <li>Name und URL der abgerufenen Datei</li>
          <li>Website, von der aus der Zugriff erfolgt (Referrer-URL)</li>
          <li>Verwendeter Browser und ggf. das Betriebssystem Ihres Rechners</li>
          <li>Name Ihres Access-Providers</li>
        </ul>

        <h3>3.2 Bei Nutzung des Kontaktformulars</h3>
        <p>
          Bei Fragen jeglicher Art bieten wir Ihnen die Möglichkeit, mit uns über ein auf der Website 
          bereitgestelltes Formular Kontakt aufzunehmen. Dabei sind folgende Angaben erforderlich:
        </p>
        <ul>
          <li>Name</li>
          <li>E-Mail-Adresse</li>
          <li>Nachrichteninhalt</li>
        </ul>
        <p>
          Die Datenverarbeitung zum Zwecke der Kontaktaufnahme mit uns erfolgt nach Art. 6 Abs. 1 lit. a 
          DSGVO auf Grundlage Ihrer freiwillig erteilten Einwilligung.
        </p>

        <h3>3.3 Newsletter</h3>
        <p>
          Wenn Sie unseren Newsletter abonnieren, verwenden wir Ihre E-Mail-Adresse und Ihren Namen für 
          den Versand des Newsletters. Die Rechtsgrundlage ist Art. 6 Abs. 1 lit. a DSGVO. Sie können 
          Ihre Einwilligung jederzeit widerrufen, indem Sie den Abmeldelink im Newsletter verwenden.
        </p>
      </section>

      <section>
        <h2>4. Weitergabe von Daten</h2>
        <p>
          Eine Übermittlung Ihrer persönlichen Daten an Dritte zu anderen als den im Folgenden 
          aufgeführten Zwecken findet nicht statt. Wir geben Ihre persönlichen Daten nur an Dritte weiter, 
          wenn:
        </p>
        <ul>
          <li>Sie Ihre ausdrückliche Einwilligung dazu erteilt haben (Art. 6 Abs. 1 lit. a DSGVO)</li>
          <li>Die Weitergabe zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen erforderlich ist (Art. 6 Abs. 1 lit. f DSGVO)</li>
          <li>Eine gesetzliche Verpflichtung zur Weitergabe besteht (Art. 6 Abs. 1 lit. c DSGVO)</li>
        </ul>
      </section>

      <section>
        <h2>5. Cookies</h2>
        <p>
          Wir setzen auf unserer Seite Cookies ein. Hierbei handelt es sich um kleine Dateien, die Ihr 
          Browser automatisch erstellt und die auf Ihrem Endgerät gespeichert werden, wenn Sie unsere 
          Seite besuchen.
        </p>
        <p>
          Cookies richten auf Ihrem Endgerät keinen Schaden an, enthalten keine Viren, Trojaner oder 
          sonstige Schadsoftware. In dem Cookie werden Informationen abgelegt, die sich jeweils im 
          Zusammenhang mit dem spezifisch eingesetzten Endgerät ergeben.
        </p>
        <p>
          Wir verwenden folgende Cookie-Typen:
        </p>
        <ul>
          <li><strong>Technisch notwendige Cookies:</strong> Diese Cookies sind zwingend erforderlich für die Funktionsfähigkeit der Website</li>
          <li><strong>Analytische Cookies:</strong> Diese Cookies helfen uns, die Nutzung unserer Website zu analysieren (Google Analytics, Facebook Pixel)</li>
          <li><strong>Marketing-Cookies:</strong> Diese Cookies werden verwendet, um Besuchern relevante Werbung anzuzeigen</li>
        </ul>
      </section>

      <section>
        <h2>6. Analyse-Tools</h2>
        <h3>6.1 Google Analytics</h3>
        <p>
          Diese Website nutzt Funktionen des Webanalysedienstes Google Analytics. Anbieter ist die Google 
          Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland.
        </p>
        <p>
          Google Analytics verwendet Cookies, die eine Analyse der Benutzung der Website durch Sie 
          ermöglichen. Die durch den Cookie erzeugten Informationen über Ihre Benutzung dieser Website 
          werden in der Regel an einen Server von Google in den USA übertragen und dort gespeichert.
        </p>

        <h3>6.2 Facebook Pixel</h3>
        <p>
          Unsere Website nutzt das Facebook-Pixel von Facebook Inc. Dadurch können wir die Aktionen von 
          Nutzern nachverfolgen, nachdem diese eine Facebook-Werbeanzeige gesehen oder angeklickt haben. 
          So können wir die Wirksamkeit der Facebook-Werbeanzeigen für statistische und Marktforschungszwecke 
          erfassen.
        </p>
      </section>

      <section>
        <h2>7. Betroffenenrechte</h2>
        <p>Sie haben das Recht:</p>
        <ul>
          <li>gemäß Art. 15 DSGVO Auskunft über Ihre von uns verarbeiteten personenbezogenen Daten zu verlangen</li>
          <li>gemäß Art. 16 DSGVO unverzüglich die Berichtigung unrichtiger oder Vervollständigung Ihrer bei uns gespeicherten personenbezogenen Daten zu verlangen</li>
          <li>gemäß Art. 17 DSGVO die Löschung Ihrer bei uns gespeicherten personenbezogenen Daten zu verlangen</li>
          <li>gemäß Art. 18 DSGVO die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen</li>
          <li>gemäß Art. 20 DSGVO Ihre personenbezogenen Daten in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten</li>
          <li>gemäß Art. 7 Abs. 3 DSGVO Ihre einmal erteilte Einwilligung jederzeit gegenüber uns zu widerrufen</li>
          <li>gemäß Art. 77 DSGVO sich bei einer Aufsichtsbehörde zu beschweren</li>
        </ul>
      </section>

      <section>
        <h2>8. Datensicherheit</h2>
        <p>
          Wir verwenden innerhalb des Website-Besuchs das verbreitete SSL-Verfahren (Secure Socket Layer) 
          in Verbindung mit der jeweils höchsten Verschlüsselungsstufe, die von Ihrem Browser unterstützt 
          wird. Ob eine einzelne Seite unseres Internetauftrittes verschlüsselt übertragen wird, erkennen 
          Sie an der geschlossenen Darstellung des Schließsymbols in der unteren Statusleiste Ihres Browsers.
        </p>
      </section>

      <section>
        <h2>9. Speicherdauer</h2>
        <p>
          Wir speichern personenbezogene Daten nur so lange, wie dies für die Erfüllung der verfolgten 
          Zwecke notwendig ist oder Sie Ihre Einwilligung nicht widerrufen haben. Im Fall eines Widerspruchs 
          löschen wir Ihre personenbezogenen Daten, es sei denn, ihre Weiterverarbeitung ist nach den 
          einschlägigen gesetzlichen Bestimmungen erlaubt.
        </p>
      </section>

      <section>
        <h2>10. Aktualität und Änderung dieser Datenschutzerklärung</h2>
        <p>
          Diese Datenschutzerklärung ist aktuell gültig und hat den Stand {new Date().toLocaleDateString('de-DE')}.
        </p>
        <p>
          Durch die Weiterentwicklung unserer Website und Angebote darüber oder aufgrund geänderter 
          gesetzlicher beziehungsweise behördlicher Vorgaben kann es notwendig werden, diese 
          Datenschutzerklärung zu ändern.
        </p>
      </section>

      <section>
        <h2>11. Kontakt</h2>
        <p>
          Bei Fragen zur Erhebung, Verarbeitung oder Nutzung Ihrer personenbezogenen Daten, bei Auskünften, 
          Berichtigung, Sperrung oder Löschung von Daten sowie Widerruf erteilter Einwilligungen wenden Sie 
          sich bitte an:
        </p>
        <p>Email: tulvod@hotmail.com</p>
            <p><a href="https://wa.me/4990874455288">WhatsApp</a></p>
            <p><a href="https://viber.me/4990874455288">Viber</a></p>
      </section>
    </div>
  
    </>);
};

export default PrivacyPolicy;